import { render } from "./FooterAdmin.vue?vue&type=template&id=1124a47d"
import script from "./FooterAdmin.vue?vue&type=script&lang=js"
export * from "./FooterAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Footers/FooterAdmin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1124a47d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1124a47d', __exports__)) {
    api.reload('1124a47d', __exports__)
  }
  
  module.hot.accept("./FooterAdmin.vue?vue&type=template&id=1124a47d", () => {
    api.rerender('1124a47d', render)
  })

}


export default __exports__